import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from './Components/homepage/Homepage';
import Nifika from './Components/nifika/Nifika';
import Corsets from './Components/corsets/Corsets';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} /> 
        <Route path="/nifika" element={<Nifika />} />
        <Route path="/corsets" element={<Corsets />} />
      </Routes>
    </Router>
  );
}

export default App;
